__turbopack_context__.v({
  "textLink": "TextLink-module__Ttzh0a__textLink",
});
